import { useCallback, useEffect, useState } from 'react';
import {
    handleEvent,
    LOCAL_MEDIA_DEVICE_KIND,
    LocalDevicesEventMediaDevicesChanged,
    LocalDevicesEventVideoInputChanged
} from '@salutejs/jazz-sdk-web';
import { toSelectOptions } from './utils';
import { handleError } from '../../utils/handleError';

export const useVideoInputDevices = (localDevices) => {
    const [videoInputDevices, setVideoInputDevices] = useState([]);
    const [videoInputDeviceId, setVideoInputDeviceId] = useState(undefined);

    const onMediaDeviceChanged = useCallback(({ payload: { groupedDevices } }: LocalDevicesEventMediaDevicesChanged) => {
        const videoInputDevices = groupedDevices[LOCAL_MEDIA_DEVICE_KIND.VIDEO_INPUT];
        setVideoInputDevices(toSelectOptions(videoInputDevices));
    }, []);

    const onVideoInputChanged = useCallback(({ payload: { device } }: LocalDevicesEventVideoInputChanged) => {
        setVideoInputDeviceId(device.deviceId);
    }, []);

    useEffect(() => {
        if (!localDevices) return;

        setVideoInputDevices(toSelectOptions(localDevices.videoInputDevices.get()));
        setVideoInputDeviceId(localDevices.videoInput.get()?.deviceId);

        const unsubscribeDevicesChanged = handleEvent(localDevices.event$, 'mediaDevicesChanged', onMediaDeviceChanged);
        const unsubscribeVideoInputChanged = handleEvent(localDevices.event$, 'videoInputChanged', onVideoInputChanged);

        return () => {
            unsubscribeDevicesChanged();
            unsubscribeVideoInputChanged();
        };
    }, [localDevices]);

    const handleChangeVideoInput = useCallback(
        (id) => {
            if (!localDevices || !id) return;

            const videoInputDevices = localDevices.videoInputDevices.get();
            const videoInputDevice = videoInputDevices.find(
                ({ deviceId }) => deviceId === id,
            );

            if (!videoInputDevice) return;

            localDevices
                .selectVideoInput(videoInputDevice)
                .catch((err) => {
                    handleError(err, 'Ошибка при выборе камеры');
                });
        },
        [localDevices],
    );

    return {
        videoInputDevices,
        videoInputDeviceId,
        handleChangeVideoInput
    }
}
